const locale = {
  common: {
    save: 'Salvar',
    cancel: 'Cancelar',
    close: 'Fechar',
    user: 'Usuário',
    account: 'Conta',
    signOut: 'Sair',
    items: 'itens',
    yes: 'Sim',
    no: 'Não',
  },
  language: {
    label: 'Idioma',
    shortLabel: 'Idioma',
    options: {
      'pt-BR': 'Português (Brasil)',
      'en-US': 'English (US)',
      'es-ES': 'Español',
    },
  },
  table: {
    empty: 'Nenhum registro encontrado',
    pagination: '{{start}}-{{end}} de {{total}} itens',
  },
  modal: {
    ok: 'Salvar',
    cancel: 'Cancelar',
  },
  sideNav: {
    internalPanel: 'Painel interno',
    userMenu: {
      account: 'Conta',
      resetPassword: 'Resetar Senha',
      signOut: 'Sair',
    },
    sections: {
      overview: 'Visão Geral',
      care: 'Atendimento',
      finance: 'Financeiro e Convênios',
      admin: 'Administração',
    },
    menu: {
      home: 'Início',
      schedules: 'Agendamentos',
      schedule: 'Agenda',
      scheduleStatus: 'Status Agenda',
      holidays: 'Feriados',
      clients: 'Clientes / Fornecedores',
      odontology: 'Odontologia',
      treatments: 'Orçamentos / Tratamentos',
      healthCertificatesControl: 'Controle de Atestados',
      templates: 'Modelos',
      healthCertificates: 'Atestados',
      documentsControl: 'Controle de Documentos',
      documents: 'Documentos',
      prescriptionTemplates: 'Modelos Receituários',
      prescriptions: 'Receituários',
      formsControl: 'Controle de Prontuários',
      medicalRecords: 'Prontuários',
      procedures: 'Procedimentos',
      financial: 'Financeiro',
      financialPlan: 'Plano de Contas',
      paymentMethods: 'Formas Pagamentos',
      payableReceivable: 'Contas à Pagar / Receber',
      cashRegister: 'Controle de Caixa',
      guidesControl: 'Controle de Guias',
      guideStatus: 'Status Guia',
      guides: 'Guias',
      professionalsControl: 'Controle de Profissionais',
      specialties: 'Especialidades',
      terminologies: 'Terminologias',
      professionals: 'Profissionais',
      covenants: 'Convênios',
      usersControl: 'Controle de Usuários',
      accessGroup: 'Grupo de Acesso',
      users: 'Usuários',
      salesControl: 'Controle de Vendas',
      productSales: 'Venda de Produtos',
      salesTracking: 'Acompanhamento de Vendas',
      inventoryControl: 'Controle de Estoque',
      productTypes: 'Tipos de Produto',
      registerProducts: 'Cadastrar Produtos',
      inventoryBalance: 'Saldo em Estoque',
      whatsapp: 'WhatsApp',
      connections: 'Conexões',
      monitoring: 'Monitoramento',
      relationship: 'Relacionamento (CRM)',
      crmCampaigns: 'Campanhas',
      crmTemplates: 'Templates',
      crmMessaging: 'Inbox / Mensagens',
      crcDashboard: 'Dashboard CRC',
      crcContacts: 'Central Contatos',
      crcPendencies: 'Pendências',
      crcReports: 'Relatórios',
      companyData: 'Dados da Empresa',
      companies: 'Empresas',
    },
  },
  auth: {
    clinicAccess: 'Acesso da clínica',
    title: 'Bem-vindo de volta',
    subtitle: 'Preencha os dados abaixo para acessar a gestão da clínica.',
    systemEntry: 'Entrar no sistema',
    panelDescription:
      'Gestão mais simples para recepção, profissionais e gestores em um único sistema.',
    support: {
      clinicCodeTitle: 'Código da clínica',
      clinicCodeDescription:
        'Identifica a unidade ou empresa que você vai acessar.',
      credentialsTitle: 'Usuário e senha',
      credentialsDescription: 'Use os dados cadastrados para sua equipe.',
      secureAccessTitle: 'Acesso seguro',
      secureAccessDescription:
        'Seus dados ficam vinculados apenas à clínica informada.',
    },
    fields: {
      clinic: 'Código da clínica',
      clinicExtra: 'Exemplo: clinica-centro',
      clinicPlaceholder: 'Digite o código da clínica',
      username: 'Usuário',
      usernamePlaceholder: 'Digite seu usuário',
      password: 'Senha',
      passwordPlaceholder: 'Digite sua senha',
    },
    validation: {
      clinicRequired: 'Por favor informe o código da clínica!',
      usernameRequired: 'Por favor informe o nome de usuário!',
      passwordRequired: 'Por favor informe sua senha!',
    },
    submit: 'Entrar no sistema',
    error: {
      title: 'Erro na autenticação',
      description:
        'Não foi possível entrar. Confira o código da clínica, o usuário e a senha.',
    },
  },
  resetPassword: {
    title: 'Resetar Senha',
    fields: {
      oldPassword: 'Senha Antiga',
      oldPasswordPlaceholder: 'Informe a antiga senha',
      newPassword: 'Senha Nova',
      newPasswordPlaceholder: 'Informe a nova senha',
      confirmPassword: 'Confirmação de Senha',
      confirmPasswordPlaceholder: 'Informe a confirmação de senha',
    },
    feedback: {
      successTitle: 'Senha Alterada',
      successDescription: 'Senha alterada com sucesso.',
      errorTitle: 'Erro',
      genericError: 'Erro ao alterar.',
      requiredFields: 'Preencha todos os campos obrigatórios.',
    },
  },
  patientLogin: {
    portalTitle: 'Portal do Paciente',
    heading: 'Acesse sua conta',
    subtitle: 'Acompanhe seus agendamentos e informações',
    tenant: {
      label: 'Código da clínica ou empresa',
      extra:
        'Se você não recebeu um link direto, informe o código da clínica ou empresa.',
      placeholder: 'Ex: clinica-centro',
      required: 'Informe o código da clínica ou empresa.',
      missing: 'Informe o código da clínica ou empresa para continuar.',
    },
    cpf: {
      label: 'CPF',
      placeholder: '000.000.000-00',
      required: 'Informe seu CPF',
      invalid: 'CPF deve ter 11 dígitos',
    },
    birthday: {
      label: 'Data de nascimento',
      placeholder: 'DD/MM/AAAA',
      required: 'Informe sua data de nascimento',
    },
    submit: 'Entrar no portal',
    hint: 'Seus dados são utilizados somente para verificar sua identidade.\nNenhuma senha é necessária.',
    errorDefault: 'CPF ou data de nascimento incorretos.',
  },
  publicSchedule: {
    hero: {
      badge: 'Agendamento online',
      title:
        'Sua clínica aberta para novos agendamentos, sem ligação e sem espera.',
      description:
        'Escolha o profissional, o melhor horário e envie sua solicitação em poucos minutos. O pedido entra direto no Sigeclin da clínica.',
    },
    highlights: {
      flowLabel: 'Fluxo',
      flowValue: 'Paciente escolhe horário e envia sozinho',
      integrationLabel: 'Integração',
      integrationValue: 'Profissionais carregados da clínica em tempo real',
      statusLabel: 'Status',
      statusValue: 'Solicitação criada com status pendente de confirmação',
    },
    metrics: {
      professionals: 'Profissionais',
      availableSlots: 'Horários livres',
      conflicts: 'Conflitos do dia',
    },
    summary: {
      title: 'Resumo da solicitação',
      clinic: 'Clínica',
      clinicPlaceholder: 'Informe o código',
      professional: 'Profissional',
      professionalPlaceholder: 'Selecione para ver agenda',
      date: 'Data',
      datePlaceholder: 'Escolha uma data',
      time: 'Horário',
      timePlaceholder: 'Defina o intervalo',
    },
    card: {
      title: 'Solicitar horário',
      subtitle:
        'Preencha seus dados e selecione o atendimento desejado para registrar o agendamento público da clínica.',
    },
    clinic: {
      label: 'Código da clínica',
      placeholder: 'Ex.: sigeclin-demo',
      required: 'Informe o código da clínica.',
      loadProfessionals: 'Carregar profissionais',
      missingTitle: 'Informe a clínica',
      missingDescription: 'Digite o código da clínica antes de continuar.',
      unavailableTitle: 'Clínica não informada',
      unavailableDescription:
        'Informe o código da clínica para solicitar seu horário.',
      loadErrorTitle: 'Erro ao carregar agenda',
      loadErrorDescription:
        'Não foi possível carregar os profissionais desta clínica.',
    },
    noProfessionals: {
      title: 'Nenhum profissional disponível',
      description:
        'Esta clínica ainda não possui profissionais públicos ativos para agendamento.',
    },
    sections: {
      patientData: '1. Dados do paciente',
      appointment: '2. Escolha do atendimento',
    },
    fields: {
      patientName: 'Nome completo',
      patientNamePlaceholder: 'Seu nome',
      patientNameRequired: 'Informe seu nome completo.',
      document: 'CPF ou CNPJ',
      documentPlaceholder: 'Somente números ou formatado',
      documentRequired: 'Informe seu CPF ou CNPJ.',
      birthday: 'Data de nascimento',
      birthdayPlaceholder: 'Selecione',
      birthdayRequired: 'Informe sua data de nascimento.',
      whatsapp: 'WhatsApp',
      whatsappPlaceholder: '(63) 99999-9999',
      whatsappRequired: 'Informe seu WhatsApp.',
      whatsappInvalid: 'Informe um celular com DDD válido.',
      email: 'E-mail',
      emailPlaceholder: 'voce@exemplo.com',
      emailInvalid: 'Informe um e-mail válido.',
      professional: 'Profissional',
      professionalPlaceholder: 'Selecione',
      professionalRequired: 'Selecione um profissional.',
      date: 'Data da consulta',
      datePlaceholder: 'Selecione',
      dateRequired: 'Escolha a data desejada.',
      startTime: 'Horário',
      startTimeRequired: 'Escolha o horário.',
      duration: 'Duração prevista',
      durationRequired: 'Escolha a duração.',
      observation: 'Observação',
      observationPlaceholder:
        'Motivo da consulta, preferência de atendimento ou observações importantes',
      privacy:
        'Autorizo o envio dos meus dados para registro e contato deste agendamento.',
      privacyRequired: 'Você precisa autorizar o envio dos dados.',
    },
    availability: {
      title: 'Agenda do profissional no dia',
      loading: 'Verificando horários ocupados...',
      reserved: 'Horário reservado',
      empty:
        'Nenhum conflito encontrado para esta data. Os horários exibidos estão livres.',
      placeholder:
        'Selecione o profissional e a data para visualizar os horários já ocupados.',
      unavailableSuffix: 'indisponível',
      errorTitle: 'Erro ao consultar disponibilidade',
      errorDescription: 'Não foi possível verificar os horários ocupados.',
    },
    durationOptions: {
      minutes30: '30 minutos',
      minutes60: '60 minutos',
    },
    warnings: {
      slotUnavailableTitle: 'Horário indisponível',
      slotUnavailableDescription:
        'Esse horário conflita com outro agendamento do profissional. Escolha outro intervalo.',
      slotOccupiedDescription:
        'Esse horário já está ocupado para o profissional selecionado.',
    },
    submit: {
      button: 'Solicitar agendamento',
      successTitle: 'Agendamento solicitado',
      successDescription: 'Sua solicitação foi registrada com sucesso.',
      errorTitle: 'Erro ao solicitar agendamento',
      errorDescription: 'Não foi possível concluir sua solicitação.',
    },
    validation: {
      title: 'Validação de disponibilidade',
      withConflicts:
        'Os horários marcados como indisponíveis já conflitam com a agenda existente do profissional.',
      withoutConflicts:
        'Os horários disponíveis já consideram os agendamentos atuais do profissional selecionado.',
    },
    success: {
      pill: 'Solicitação registrada',
      title: 'Seu horário entrou na agenda da clínica.',
      description:
        'O pedido foi salvo com sucesso no Sigeclin. Se necessário, a clínica poderá confirmar os detalhes por WhatsApp ou outro canal cadastrado.',
      patient: 'Paciente',
      professional: 'Profissional',
      start: 'Início',
      status: 'Status',
      nextStepTitle: 'Próximo passo',
      nextStepDescription:
        'Você pode fechar esta página ou enviar outra solicitação de horário, se precisar.',
      newRequest: 'Fazer novo agendamento',
    },
  },
  patientPortal: {
    popupBlocked:
      'Não foi possível abrir a tela de impressão. Verifique o bloqueador de pop-ups.',
    sessionExpired: 'Sessão expirada. Faça login novamente.',
    loadError: 'Não foi possível carregar os dados.',
    retryLogin: 'Fazer login novamente',
    logout: 'Sair',
    profile: {
      cpf: 'CPF',
      birthDate: 'Nascimento',
    },
    tabs: {
      schedules: 'Agendamentos',
      schedulesShort: 'Agenda',
      treatments: 'Tratamentos',
      treatmentsShort: 'Trat.',
      financials: 'Financeiro',
      financialsShort: 'Fin.',
      healthCertificates: 'Atestados',
      healthCertificatesShort: 'Atest.',
      prescriptions: 'Receituários',
      prescriptionsShort: 'Receitas',
      documents: 'Documentos',
      documentsShort: 'Docs',
      forms: 'Prontuários',
      formsShort: 'Pront.',
    },
    schedules: {
      empty: 'Você não possui agendamentos futuros.',
      status: {
        confirmed: 'Confirmado',
        pending: 'Pendente',
        cancelled: 'Cancelado',
      },
    },
    financials: {
      empty: 'Nenhum registro financeiro encontrado.',
      open: 'Em aberto',
      paid: 'Pago',
      unknown: 'Desconhecido',
      codePrefix: 'Nº',
      dueDate: 'Vencimento',
      paymentDate: 'Pagamento',
    },
    healthCertificates: {
      empty: 'Nenhum atestado encontrado.',
      title: 'Atestado',
      daysSingle: 'dia',
      daysPlural: 'dias',
      cid: 'CID',
      printCopy: 'Imprimir 2ª via',
    },
    documents: {
      empty: 'Nenhum documento encontrado.',
      prescriptionHeading: 'Receituário',
      documentHeading: 'Documento',
      signed: 'Assinado',
      printCopy: 'Imprimir 2ª via',
    },
    prescription: {
      digital: 'Receituário digital',
      signed: 'Assinado digitalmente',
      validation: 'Validação',
      signedNotice: 'Este receituário foi assinado e possui validade digital.',
      medicines: 'Medicamentos prescritos',
      medicineFallback: 'Medicamento {{index}}',
      dosage: 'Dosagem',
      frequency: 'Frequência',
      duration: 'Duração',
      instructions: 'Instruções',
      guidelines: 'Orientações',
      printable: 'Este receituário está disponível para impressão.',
    },
    treatments: {
      empty: 'Nenhum tratamento encontrado.',
      budget: 'Orçamento',
      treatment: 'Tratamento',
      approved: 'Aprovado',
      notApproved: 'Não aprovado',
      professionalMissing: 'Profissional não informado',
      total: 'Total',
      progress: 'Progresso do tratamento',
      procedures: 'Procedimentos',
      procedureFallback: 'Procedimento',
      quantity: 'Qtd',
      noProcedures: 'Nenhum procedimento registrado.',
      history: 'Histórico de evoluções',
      records: 'Registros',
      averageRank: 'Rank médio',
      lastRank: 'Último rank',
      chartTitle: 'Gráfico da evolução',
      rankDataset: 'Rank da evolução',
      rankTooltip: 'Rank',
      observationTooltip: 'Obs.',
      noObservation: 'Sem observações informadas.',
      noHistory: 'Nenhuma evolução registrada para este tratamento.',
      status: {
        pending: 'Pendente',
        inProgress: 'Em andamento',
        completed: 'Concluído',
        finished: 'Finalizado',
      },
      timeAt: 'às',
      procedureLabel: 'Procedimento',
      signed: 'Assinada',
    },
    forms: {
      empty: 'Nenhum prontuário encontrado.',
      title: 'Prontuário',
      code: 'Código',
      signed: 'Assinado',
      professional: 'Profissional',
      validationCode: 'Código de validação',
      infoSection: 'Informações do prontuário',
      notInformed: 'Não informado',
      noFields: 'Não há informações preenchidas neste prontuário.',
      evolutions: 'Evoluções',
      evaluation: 'Avaliação',
      noObservation: 'Sem observações informadas.',
      noEvolution: 'Nenhuma evolução registrada para este prontuário.',
      timeAt: 'às',
    },
  },
  dashboard: {
    error: {
      title: 'Erro',
      financials: 'Erro ao listar contas financeiras',
      schedules: 'Erro ao listar os agendamentos',
    },
    hero: {
      badge: 'Painel principal',
      greeting: 'Olá, {{name}}',
      subtitle: 'Veja rapidamente os números mais importantes da clínica hoje.',
    },
    actions: {
      viewSchedule: 'Ver agenda',
      goFinancials: 'Ir para financeiro',
      quickTitle: 'Ações rápidas',
      cashFlow: 'Fluxo de Caixa',
      fullSchedule: 'Agenda Completa',
      createExpense: 'Lançar Despesa',
      details: 'Ver detalhes',
      overdueAccounts: 'Ver Contas',
      receivables: 'Ver Recebíveis',
      report: 'Relatório',
    },
    tooltips: {
      goSchedule: 'Ir para Agenda',
      whatsappSettings: 'Configurações WhatsApp',
    },
    cards: {
      schedulesToday: 'AGENDAMENTOS HOJE',
      schedulesDescription: 'Total de pacientes agendados',
      overduePayables: 'A PAGAR (VENCIDAS)',
      pendingTitles: '{{count}} títulos pendentes',
      receivablesToday: 'A RECEBER HOJE',
      expectedInvoices: '{{count}} faturas previstas',
      whatsappMonth: 'WHATSAPP (MÊS)',
      whatsappDescription: 'Envios registrados via API Meta',
      attention: 'Atenção',
    },
  },
  schedulesPage: {
    error: {
      title: 'Erro',
      listSchedules: 'Erro ao listar os agendamentos',
      listProfessionals: 'Erro ao listar profissionais',
      listHolidays: 'Erro ao listar feriados',
      listClients: 'Erro ao listar clientes',
      listStatus: 'Erro ao listar status',
    },
    info: {
      holidayTitle: 'Feriado',
      confirmedAt: 'Confirmado em: {{date}}',
    },
    intro: {
      badge: 'Agenda',
      title: 'Agenda da clínica',
      description:
        'Organize atendimentos, visualize confirmações e acompanhe a ocupação da equipe em uma visão única.',
    },
    actions: {
      newSchedule: 'Novo agendamento',
      reports: 'Relatórios',
      schedulesReport: 'Relatório de Agendamentos',
    },
    filters: {
      professional: 'Profissional',
      professionalPlaceholder: 'Filtrar por profissional',
      allProfessionals: 'Todos os profissionais',
    },
    calendar: {
      today: 'Hoje',
      month: 'Mês',
      week: 'Semana',
      day: 'Dia',
      list: 'Lista',
    },
  },
  scheduleConfirm: {
    loading: 'Carregando agendamento...',
    error: {
      title: 'Erro',
      foundSuccess: 'Agendamento encontrado com sucesso!',
      invalidLink: 'Link inválido ou expirado',
      missingParams: 'Link inválido: parâmetros ausentes',
      processConfirmation: 'Erro ao processar confirmação',
      invalidTitle: 'Link Inválido ou Expirado',
      notFoundTitle: 'Agendamento não encontrado',
      notFoundDescription:
        'Desculpe, não conseguimos encontrar esse agendamento.',
    },
    confirmation: {
      successTitle: 'Sucesso',
      confirmedSuccess: 'Agendamento confirmado com sucesso!',
      cancelledSuccess: 'Agendamento recusado com sucesso!',
      confirmedToast: 'Seu agendamento foi confirmado',
      cancelledToast: 'Sua recusa foi registrada',
      confirmedCardTitle: 'Agendamento Confirmado!',
      cancelledCardTitle: 'Agendamento Cancelado',
      confirmedAt: 'Confirmado em: {{date}}',
      backHome: 'Voltar ao Início',
    },
    hero: {
      title: 'Confirmação de Agendamento',
      description:
        'Revise os detalhes da sua consulta e confirme para prosseguir',
    },
    details: {
      dateTime: 'Data e Hora',
      fromTo: '{{date}} de {{start}} até {{end}}',
      daysUntilOne: 'Falta {{count}} dia',
      daysUntilOther: 'Faltam {{count}} dias',
      clinic: 'Clínica',
      professional: 'Profissional',
      patient: 'Paciente',
      phone: 'Telefone',
      address: 'Endereço',
      observation: 'Observação',
    },
    decision: {
      title: 'Como deseja proceder?',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
      cancelReason: 'Motivo do cancelamento',
      cancelReasonPlaceholder:
        'Nos ajude a melhorar deixando o motivo do cancelamento...',
      confirmAction: 'Confirmar Agendamento',
      cancelAction: 'Cancelar Agendamento',
    },
    modal: {
      confirmTitle: 'Confirmar Agendamento',
      cancelTitle: 'Cancelar Agendamento',
      confirmOk: 'Sim, Confirmar',
      cancelOk: 'Sim, Cancelar',
      back: 'Não, Voltar',
      confirmQuestion: 'Você confirma que deseja agendar esta consulta?',
      cancelQuestion: 'Você tem certeza que deseja cancelar este agendamento?',
      confirmDescription: 'Você receberá uma confirmação no seu email',
      cancelDescription: 'A clínica receberá notificação do cancelamento',
    },
  },
  financialsPage: {
    toast: {
      errorTitle: 'Erro',
      warningTitle: 'Aviso',
      listPayments: 'Erro ao listar formas de pagamento',
      selectAtLeastOne: 'Selecione pelo menos uma conta',
      removeCancelled: 'Remova as contas canceladas da seleção',
      selectPendingOnly: 'Selecione apenas contas pendentes para pagar',
      listAccounts: 'Erro ao listar contas',
    },
    status: {
      cancelled: 'Cancelado',
      received: 'Recebido',
      overdue: 'Atrasado',
      pending: 'Pendente',
      open: 'Aberto',
      paid: 'Pago',
      openPaid: 'Aberto/Pago',
    },
    actions: {
      edit: 'Editar',
      pay: 'Baixar/Pagar',
      reverse: 'Estornar',
      receipt: 'Recibo',
      newEntry: 'Novo Lançamento',
      cashRegister: 'Controle de Caixa',
      quickSale: 'Venda Rápida',
      paySelected: 'Baixar Selecionados',
      cancelSelected: 'Cancelar Selecionados',
      reports: 'Relatórios',
      cashFlow: 'Fluxo de Caixa',
      dre: 'DRE',
      accountsPayable: 'Contas a Pagar',
      accountsReceivable: 'Contas a Receber',
      movements: 'Movimentação Financeira',
      delinquency: 'Inadimplência',
      advancedReports: 'Relatórios avançados',
      commissionClosing: 'Fechamento de comissões',
      moreActions: 'Mais ações',
      back: 'Voltar',
      clear: 'Limpar',
      filter: 'Filtrar',
    },
    intro: {
      badge: 'Financeiro',
      title: 'Gestão financeira',
      description:
        'Acompanhe receitas, despesas e inadimplência com filtros rápidos e visão consolidada dos principais valores do período.',
    },
    filters: {
      searchPlaceholder: 'Pesquisar...',
      advanced: 'Filtros avançados',
      typePlaceholder: 'Tipo',
      typeIncome: 'Receita',
      typeExpense: 'Despesa',
      statusPlaceholder: 'Status',
      filterByPlaceholder: 'Filtrar por',
      dueDate: 'Vencimento',
      paymentDate: 'Pagamento',
      competenceDate: 'Competência',
    },
    summary: {
      confirmedReceived: 'Recebido (Confirmado)',
      pendingReceivable: 'A Receber (Pendente)',
      paidExpenses: 'Pago (Despesas)',
      pendingPayable: 'A Pagar (Pendente)',
    },
    table: {
      id: 'ID',
      type: 'Tipo',
      clientCode: 'Cód.',
      clientSupplier: 'Cliente/Fornecedor',
      dueDate: 'Vencimento',
      paymentDate: 'Pagamento',
      value: 'Valor',
      paymentMethod: 'Forma Pag.',
      status: 'Status',
      income: 'RECEITA',
      expense: 'DESPESA',
    },
    createEdit: {
      titleCreate: 'Novo lançamento financeiro',
      titleEdit: 'Editar lançamento Nº {{code}}',
      description:
        'Cadastre receitas e despesas com uma estrutura visual consistente e foco nas informações principais do lançamento.',
      sections: {
        entryInfo: 'Informações do Lançamento',
        financialDetails: 'Detalhes Financeiros',
        observations: 'Observações',
      },
      movementTypes: {
        income: 'Receita (Entrada)',
        expense: 'Despesa (Saída)',
      },
      fields: {
        movementType: 'Tipo de Movimento',
        description: 'Descrição',
        descriptionPlaceholder: 'Ex: Aluguel, Venda Balcão...',
        client: 'Cliente',
        supplier: 'Fornecedor',
        selectPlaceholder: 'Selecione...',
        accountPlan: 'Plano de Contas',
        accountPlanPlaceholder: 'Classificação...',
        value: 'Valor (R$)',
        dueDate: 'Vencimento',
        paymentMethod: 'Forma de Pagamento',
        documentNumber: 'Nº Documento',
        installments: 'Parcelas',
        options: 'Opções',
        repeatValue: 'Repetir Valor',
        splitValue: 'Dividir Valor',
        observationsPlaceholder: 'Detalhes adicionais sobre este lançamento...',
      },
      actions: {
        create: 'Cadastrar Lançamento',
        save: 'Salvar Alterações',
      },
      toast: {
        loadDataError: 'Erro ao carregar dados',
        loadDependenciesError: 'Erro ao carregar dependências',
        successTitle: 'Sucesso',
        errorTitle: 'Erro',
        warningTitle: 'Atenção',
        created: 'Lançamento criado com sucesso',
        updated: 'Lançamento atualizado',
        checkFields: 'Verifique os campos',
      },
      validation: {
        typeRequired: 'Tipo obrigatório',
        clientRequired: 'Cliente obrigatório',
        descriptionRequired: 'Descrição obrigatória',
        dueDateRequired: 'Data de vencimento obrigatória',
        valueMin: 'Valor deve ser maior que zero',
        valueRequired: 'Valor obrigatório',
        documentNumberRequired: 'Número de documento obrigatório',
      },
    },
  },
  statusFinancial: {
    open: 'Aberto',
    paid: 'Pago',
    overdue: 'Vencido',
    cancelled: 'Cancelado',
  },
  statusItemTreatment: {
    inProgress: 'Em andamento',
    completed: 'Concluído',
    pending: 'Pendente',
  },
  treatmentsPage: {
    toast: {
      errorTitle: 'Erro',
      listError: 'Erro ao listar tratamentos',
    },
    actions: {
      refresh: 'Atualizar',
      create: 'Cadastrar',
      reports: 'Relatórios',
      production: 'Produção',
      treatments: 'Tratamentos',
      procedures: 'Procedimentos',
      moreActions: 'Mais ações',
      back: 'Voltar',
      view: 'Visualizar',
      approveReject: 'Aprovar/Recusar',
      edit: 'Editar',
      evolution: 'Evolução',
      print: 'Imprimir',
    },
    intro: {
      badge: 'Tratamentos',
      title: 'Orçamentos e tratamentos',
      description:
        'Acompanhe aprovações, progresso dos atendimentos e a evolução dos tratamentos em uma visão única.',
    },
    searchPlaceholder: 'Pesquisar...',
    stats: {
      total: 'Total',
      approved: 'Aprovados',
      pending: 'Pendentes',
      inProgress: 'Em andamento',
    },
    filters: {
      all: 'Todos',
      budgets: 'Orçamentos',
      treatments: 'Tratamentos',
    },
    table: {
      id: 'Id',
      type: 'Tipo',
      client: 'Cliente',
      professional: 'Profissional',
      total: 'Total',
      progress: 'Progresso',
      situation: 'Situação',
      signature: 'Assinatura',
      options: 'Opções',
      typeTreatment: 'TRAT',
      typeBudget: 'ORÇ',
      approved: 'Aprovado',
      rejected: 'Recusado',
      pending: 'Pendente',
      signed: 'Assinado',
      unsigned: 'Não assinado',
    },
  },
  clientsPage: {
    toast: {
      errorTitle: 'Erro',
      listError: 'Erro ao listar clientes',
    },
    intro: {
      badge: 'Cadastros',
      title: 'Clientes e fornecedores',
      description:
        'Acompanhe a base cadastral da clínica, pesquise rapidamente e acesse os principais relatórios sem sair da listagem.',
    },
    actions: {
      refresh: 'Atualizar',
      create: 'Cadastrar',
      clientsReport: 'Relatório de Clientes',
      birthdays: 'Aniversariantes',
    },
    table: {
      id: 'Id',
      type: 'Tipo',
      document: 'CPF/CNPJ',
      name: 'Razão Social/Nome',
      phone: 'Celular',
      status: 'Status',
      options: 'Opções',
      code: 'Código',
    },
  },
  proceduresPage: {
    toast: {
      errorTitle: 'Erro',
      listError: 'Erro ao listar procedimentos',
    },
    intro: {
      badge: 'Cadastros',
      title: 'Procedimentos',
      description:
        'Gerencie os procedimentos disponíveis, revise preços e acesse rapidamente o cadastro e a edição dos itens.',
    },
    actions: {
      refresh: 'Atualizar',
      create: 'Cadastrar',
      edit: 'Editar',
    },
    table: {
      id: 'Id',
      description: 'Descrição',
      price: 'Preço',
      status: 'Status',
      options: 'Opções',
    },
    modal: {
      validation: {
        descriptionRequired: 'Descrição obrigatória',
        priceMin: 'Valor deve ser maior que zero',
        priceRequired: 'Preço obrigatório',
        statusRequired: 'Status obrigatório',
      },
      toast: {
        successTitle: 'Cadastrado',
        infoTitle: 'Alterado',
        errorTitle: 'Erro',
        blankFieldsTitle: 'Campos em branco',
        createdDescription: 'Cadastrado com sucesso.',
        updatedDescription: 'Dados alterados com sucesso.',
        createError: 'Erro ao cadastrar',
        editError: 'Erro ao editar.',
      },
      titleCreate: 'Cadastrar',
      titleEdit: 'Editar',
      fields: {
        description: 'Descrição',
        descriptionPlaceholder: 'Informe a descrição',
        price: 'Preço',
        pricePlaceholder: 'Informe o preço',
        active: 'Ativo',
        dental: 'É odontológico?',
      },
    },
  },
  specialtiesModal: {
    validation: {
      descriptionRequired: 'Descrição obrigatória',
      statusRequired: 'Status obrigatório',
    },
    toast: {
      successTitle: 'Cadastrado',
      infoTitle: 'Alterado',
      errorTitle: 'Erro',
      blankFieldsTitle: 'Campos em branco',
      createdDescription: 'Cadastrado com sucesso.',
      updatedDescription: 'Dados alterados com sucesso.',
      createError: 'Erro ao cadastrar.',
      editError: 'Erro ao alterar.',
    },
    titleCreate: 'Cadastrar',
    titleEdit: 'Editar',
    fields: {
      description: 'Descrição',
      descriptionPlaceholder: 'Informe a descrição',
      active: 'Ativo',
    },
  },
  covenantsModal: {
    validation: {
      descriptionRequired: 'Descrição obrigatória',
      statusRequired: 'Status obrigatório',
    },
    toast: {
      successTitle: 'Cadastrado',
      infoTitle: 'Alterado',
      errorTitle: 'Erro',
      blankFieldsTitle: 'Campos em branco',
      createdDescription: 'Cadastrado com sucesso.',
      updatedDescription: 'Dados alterados com sucesso.',
      createError: 'Erro ao cadastrar.',
      editError: 'Erro ao editar.',
    },
    titleCreate: 'Cadastrar',
    titleEdit: 'Editar',
    fields: {
      description: 'Descrição',
      descriptionPlaceholder: 'Informe a descrição',
      active: 'Ativo',
    },
  },
  addressModal: {
    validation: {
      cepRequired: 'CEP obrigatório',
      streetRequired: 'Logradouro obrigatório',
      neighborhoodRequired: 'Bairro obrigatório',
      cityRequired: 'Cidade obrigatória',
      stateRequired: 'Estado obrigatório',
    },
    toast: {
      successTitle: 'Cadastrado',
      infoTitle: 'Alterado',
      errorTitle: 'Erro',
      blankFieldsTitle: 'Campos em branco',
      cepNotFoundTitle: 'CEP não encontrado',
      cepNotFoundDescription: 'Não foi possível encontrar o CEP informado.',
      createdDescription: 'Cadastrado com sucesso.',
      updatedDescription: 'Dados alterados com sucesso.',
    },
    titleCreate: 'Cadastrar',
    titleEdit: 'Editar',
    fields: {
      cep: 'CEP',
      cepPlaceholder: 'CEP',
      street: 'Logradouro',
      streetPlaceholder: 'Informe o logradouro',
      number: 'Número',
      numberPlaceholder: 'Informe o número',
      neighborhood: 'Bairro',
      neighborhoodPlaceholder: 'Informe o bairro',
      complement: 'Complemento',
      complementPlaceholder: 'Informe o complemento',
      city: 'Cidade',
      cityPlaceholder: 'Informe a cidade',
      state: 'UF',
      statePlaceholder: 'Informe o UF',
      active: 'Ativo',
    },
  },
  productCategoriesModal: {
    validation: {
      descriptionRequired: 'Descrição obrigatória',
    },
    toast: {
      successTitle: 'Cadastrado',
      infoTitle: 'Alterado',
      errorTitle: 'Erro',
      blankFieldsTitle: 'Campos em branco',
      createdDescription: 'Cadastrado com sucesso.',
      updatedDescription: 'Dados alterados com sucesso.',
      createError: 'Erro ao cadastrar.',
      editError: 'Erro ao editar.',
    },
    titleCreate: 'Cadastrar',
    titleEdit: 'Editar',
    fields: {
      description: 'Descrição da categoria',
      descriptionPlaceholder: 'Informe uma descrição objetiva',
      descriptionHelp:
        'Essa descrição será usada para organizar os produtos no estoque.',
      status: 'Status',
      activeDescription: 'Categoria ativa para novos produtos',
      inactiveDescription: 'Categoria inativa',
    },
  },
  schedulesStatusModal: {
    validation: {
      descriptionRequired: 'Descrição obrigatória',
      colorRequired: 'Cor obrigatória',
      statusRequired: 'Status obrigatório',
    },
    toast: {
      successTitle: 'Cadastrado',
      infoTitle: 'Alterado',
      errorTitle: 'Erro',
      blankFieldsTitle: 'Campos em branco',
      createdDescription: 'Cadastrado com sucesso.',
      updatedDescription: 'Dados alterados com sucesso.',
      createError: 'Erro ao cadastrar.',
      editError: 'Erro ao editar.',
    },
    titleCreate: 'Cadastrar',
    titleEdit: 'Editar',
    fields: {
      description: 'Descrição',
      descriptionPlaceholder: 'Informe a descrição',
      color: 'Cor',
      colorPlaceholder: 'Informe a cor',
      active: 'Ativo',
    },
  },
  guidesStatusModal: {
    validation: {
      descriptionRequired: 'Descrição obrigatória',
      colorRequired: 'Cor obrigatória',
      statusRequired: 'Status obrigatório',
    },
    toast: {
      successTitle: 'Cadastrado',
      infoTitle: 'Alterado',
      errorTitle: 'Erro',
      blankFieldsTitle: 'Campos em branco',
      createdDescription: 'Cadastrado com sucesso.',
      updatedDescription: 'Dados alterados com sucesso.',
      createError: 'Erro ao cadastrar.',
      editError: 'Erro ao editar.',
    },
    titleCreate: 'Cadastrar',
    titleEdit: 'Editar',
    fields: {
      description: 'Descrição',
      descriptionPlaceholder: 'Informe a descrição',
      color: 'Cor',
      colorPlaceholder: 'Informe a cor',
      active: 'Ativo',
    },
  },
  financialPlansModal: {
    validation: {
      descriptionRequired: 'Descrição obrigatória',
      statusRequired: 'Status obrigatório',
    },
    toast: {
      successTitle: 'Cadastrado',
      infoTitle: 'Alterado',
      errorTitle: 'Erro',
      blankFieldsTitle: 'Campos em branco',
      createdDescription: 'Cadastrado com sucesso.',
      updatedDescription: 'Dados alterados com sucesso.',
      createError: 'Erro ao cadastrar.',
      editError: 'Erro ao editar.',
    },
    titleCreate: 'Cadastrar',
    titleEdit: 'Editar',
    fields: {
      description: 'Descrição',
      descriptionPlaceholder: 'Informe a descrição',
      active: 'Ativo',
    },
  },
  holidaysModal: {
    validation: {
      descriptionRequired: 'Descrição obrigatória',
      dayRequired: 'Dia obrigatório',
      monthRequired: 'Mês obrigatório',
      statusRequired: 'Status obrigatório',
    },
    toast: {
      successTitle: 'Cadastrado',
      infoTitle: 'Alterado',
      errorTitle: 'Erro',
      blankFieldsTitle: 'Campos em branco',
      createdDescription: 'Cadastrado com sucesso.',
      updatedDescription: 'Dados alterados com sucesso.',
      createError: 'Erro ao cadastrar.',
      editError: 'Erro ao editar.',
    },
    titleCreate: 'Cadastrar',
    titleEdit: 'Editar',
    fields: {
      description: 'Descrição',
      descriptionPlaceholder: 'Informe a descrição',
      day: 'Dia',
      dayPlaceholder: 'Selecione o dia',
      month: 'Mês',
      monthPlaceholder: 'Selecione o mês',
      active: 'Ativo',
    },
    months: {
      january: 'Janeiro',
      february: 'Fevereiro',
      march: 'Março',
      april: 'Abril',
      may: 'Maio',
      june: 'Junho',
      july: 'Julho',
      august: 'Agosto',
      september: 'Setembro',
      october: 'Outubro',
      november: 'Novembro',
      december: 'Dezembro',
    },
  },
  toSignature: {
    title: 'Autenticar assinatura digital',
    fields: {
      password: 'Senha de assinatura',
      passwordPlaceholder: 'Informe a senha de assinatura do profissional',
    },
    toast: {
      warningTitle: 'Aviso',
      errorTitle: 'Erro',
      passwordRequired: 'Informe a senha de assinatura',
    },
  },
  productModal: {
    validation: {
      nameRequired: 'Descrição obrigatória',
      productTypeRequired: 'Tipo do produto obrigatório',
      salePriceMin: 'Preço de venda deve ser maior que zero',
      salePriceRequired: 'Preço de venda obrigatório para produto vendável',
      salePriceInvalid: 'Preço inválido',
      minimumInventoryMin: 'Estoque mínimo deve ser maior que zero',
      minimumInventoryRequired: 'Estoque mínimo obrigatório',
      maximumInventoryMin: 'Estoque máximo deve ser maior que zero',
      maximumInventoryRequired: 'Estoque máximo obrigatório',
    },
    toast: {
      successTitle: 'Cadastrado',
      infoTitle: 'Alterado',
      errorTitle: 'Erro',
      blankFieldsTitle: 'Campos em branco',
      createdDescription: 'Cadastrado com sucesso.',
      updatedDescription: 'Dados alterados com sucesso.',
      createError: 'Erro ao cadastrar.',
      editError: 'Erro ao editar.',
    },
    titleCreate: 'Cadastrar',
    titleEdit: 'Editar',
    productTypes: {
      supply: 'Insumo',
      retail: 'Produto para venda',
    },
    sections: {
      inventory: 'Controle de estoque',
    },
    fields: {
      name: 'Nome',
      namePlaceholder: 'Informe o nome do produto',
      description: 'Descrição',
      descriptionPlaceholder:
        'Adicione uma descrição curta para facilitar a identificação',
      category: 'Categoria do produto',
      categoryPlaceholder: 'Selecione a categoria',
      productType: 'Tipo do produto',
      unity: 'Unidade',
      unityPlaceholder: 'Selecione',
      salePrice: 'Preço base de venda',
      salePricePlaceholder: 'Ex: 49.90',
      salePriceDisabledPlaceholder: 'Não se aplica para insumos',
      minimumInventory: 'Estoque mínimo',
      minimumInventoryPlaceholder: 'Ex: 10',
      maximumInventory: 'Estoque máximo',
      maximumInventoryPlaceholder: 'Ex: 100',
      inventoryHelp: 'Informe os limites para alertas de reposição',
      inventoryRange: 'Faixa configurada: {{min}} até {{max}}{{unity}}',
      productStatus: 'Status do produto',
      activeDescription: 'Produto ativo para movimentações',
      inactiveDescription: 'Produto inativo',
    },
  },
  inventoryEntriesPage: {
    toast: {
      errorTitle: 'Erro',
      listEntries: 'Erro ao listar as entradas',
      listProducts: 'Erro ao listar os produtos',
    },
    intro: {
      badge: 'Estoque',
      title: 'Reposições do estoque',
      description:
        'Use esta tela quando um produto entrou na clínica: compra, reposição, devolução ou acerto manual de quantidade.',
    },
    actions: {
      refresh: 'Atualizar',
      newEntry: 'Nova Entrada',
      view: 'Visualizar',
    },
    stats: {
      registeredEntries: 'Reposições registradas',
      purchasedValue: 'Valor comprado',
      receivedQuantity: 'Quantidade recebida',
      usedSuppliers: 'Fornecedores usados',
    },
    table: {
      date: 'Data',
      product: 'Produto',
      source: 'De quem veio',
      receivedQuantity: 'Qtd. recebida',
      unitPrice: 'Preço unitário',
      options: 'Opções',
    },
  },
  modelsFormsCreateEdit: {
    validation: {
      titleRequired: 'Título obrigatório',
      missingInputs: 'Está faltando os campos do formulário',
      inputTypeRequired: 'Tipo obrigatório',
      inputLabelRequired: 'Campo obrigatório',
    },
    toast: {
      infoTitle: 'Informação',
      successTitle: 'Sucesso',
      errorTitle: 'Erro',
      blankFields: 'Campos em branco',
      updated: 'Prontuário alterado com sucesso',
      created: 'Prontuário cadastrado com sucesso',
      createError: 'Erro ao Cadastrar',
      editError: 'Erro ao Editar',
    },
    intro: {
      badge: 'Modelos',
      createTitle: 'Cadastrar modelo prontuário',
      editTitle: 'Editar modelo prontuário',
      description:
        'Configure modelos de prontuário e seus campos com o novo shell visual compartilhado.',
    },
    fields: {
      title: 'Título',
      titlePlaceholder: 'Título do prontuário',
      description: 'Descrição',
      descriptionPlaceholder: 'Descrição do prontuário',
      active: 'Ativo',
      inputs: 'Campos',
      addInput: 'Adicionar campo',
    },
    inputModal: {
      validation: {
        noOptionsTitle: 'Sem opções',
        noOptionsDescription: 'Precisa de pelo menos uma opção',
        emptyOptionsTitle: 'Opção(ões) sem valor(es)',
        emptyOptionsDescription: 'Campo(s) de opção(ões) sem valor(res)',
      },
      toast: {
        successTitle: 'Sucesso',
        infoTitle: 'Alterado',
        errorTitle: 'Erro',
        blankFields: 'Campos em branco',
        created: 'Cadastrado com sucesso.',
        updated: 'Alterado com sucesso.',
        createError: 'Erro ao Cadastrar',
        editError: 'Erro ao Editar.',
      },
      titleCreate: 'Cadastrar',
      titleEdit: 'Editar',
      fields: {
        type: 'Tipo de campo',
        typePlaceholder: 'Informe o tipo do campo',
        question: 'O texto da pergunta',
        questionPlaceholder: 'Informe o texto',
        order: 'Ordem da pergunta',
        orderPlaceholder: 'Informe a ordem do campo Ex: 1, 2, 3...',
        required: 'Obrigatório?',
        active: 'Ativo',
        options: 'Opções',
        addOption: 'Adicionar opção',
        optionValuePlaceholder: 'Valor',
      },
    },
  },
  modelsDocumentsCreateEdit: {
    validation: {
      titleRequired: 'Nome obrigatório',
    },
    toast: {
      infoTitle: 'Alterado',
      errorTitle: 'Erro',
      blankFields: 'Campos em branco',
      createdTitle: 'Cadastrado',
      created: 'Cadastrado com sucesso.',
      copiedTitle: 'Copiado',
      copiedDescription:
        'Palavra-chave "{{keyword}}" copiada para a área de transferência',
      updated: 'Dados alterados com sucesso.',
      createError: 'Erro ao Cadastrar',
      editError: 'Erro ao Editar',
    },
    intro: {
      badge: 'Modelos',
      createDocument: 'Cadastrar modelo de documento',
      editDocument: 'Editar modelo de documento',
      createPrescription: 'Cadastrar modelo de receituário',
      editPrescription: 'Editar modelo de receituário',
      prescriptionDescription:
        'Configure um modelo de receituário eletrônico com placeholders próprios para itens prescritos, data e orientações.',
      documentDescription:
        'Configure modelos reutilizáveis de documentos dentro do novo padrão visual do sistema.',
    },
    status: {
      active: 'ATIVO',
      inactive: 'INATIVO',
    },
    sections: {
      basicInfo: 'Informações Básicas',
      keywords: 'Palavras-chave Disponíveis',
      content: 'Conteúdo do Documento',
      modelStatus: 'Status do Modelo',
    },
    fields: {
      prescriptionTitle: 'Título do Receituário',
      documentTitle: 'Título do Documento',
      modelType: 'Tipo do Modelo',
      text: 'Texto',
      activateModel: 'Ativar modelo',
    },
    placeholders: {
      titleExample: 'Ex.: LAUDO DE AVALIAÇÃO',
    },
    tooltips: {
      modelName: 'Nome que identifica este modelo',
      modelNameDescription:
        'Digite um nome descritivo para este modelo (ex: LAUDO DE AVALIAÇÃO)',
      deactivateModel: 'Desative para ocultar este modelo dos usuários',
      copyKeyword: 'Copiar palavra-chave',
    },
    options: {
      document: 'Documento',
      prescription: 'Receituário eletrônico',
    },
    instructions: {
      keywords:
        'Copie e cole as palavras-chave no texto do modelo. Elas serão automaticamente substituídas pelos dados do cliente quando o documento for gerado.',
      importantTitle: 'Importante:',
      importantDescription:
        'As palavras-chave devem ser digitadas exatamente como mostrado acima',
      content:
        'Escreva o texto do documento. Use as palavras-chave acima para inserir dados dinâmicos que serão preenchidos automaticamente.',
    },
    keywords: {
      name: 'Nome do cliente',
      cpf: 'CPF do cliente',
      birthDate: 'Data de nascimento do cliente',
      phone: 'Nº celular do cliente',
      gender: 'Sexo do cliente',
      maritalStatus: 'Estado civil do cliente',
      email: 'E-mail do cliente',
      nationality: 'Nacionalidade do cliente',
      naturalness: 'Naturalidade do cliente',
      profession: 'Profissão do cliente',
      zipCode: 'CEP do endereço do cliente',
      street: 'Logradouro do endereço do cliente',
      number: 'Número do endereço do cliente',
      district: 'Bairro do endereço do cliente',
      complement: 'Complemento do endereço do cliente',
      city: 'Cidade do endereço do cliente',
      state: 'Estado do endereço do cliente',
      prescriptionDate: 'Data de emissão do receituário',
      prescriptionItems: 'Lista dos medicamentos prescritos',
      prescriptionGuidelines: 'Orientações complementares do receituário',
    },
    template: {
      patient: 'Paciente',
      date: 'Data',
    },
  },
  sendScheduleConfirmation: {
    defaultClientName: 'Cliente',
    messages: {
      copied: 'Link copiado para a área de transferência!',
      emailRequired: 'Informe um endereço de email',
      emailSent: 'Email enviado com sucesso!',
      emailError: 'Erro ao enviar email',
      phoneRequired: 'Informe um número de telefone',
      whatsappSent: 'Mensagem do WhatsApp enviada com sucesso!',
      whatsappError: 'Erro ao enviar WhatsApp',
    },
    title: 'Enviar Link de Confirmação de Agendamento',
    close: 'Fechar',
    to: 'Para',
    sections: {
      link: 'Link de Confirmação',
      email: 'Enviar por Email',
      whatsapp: 'Enviar por WhatsApp',
      info: 'Informações importantes:',
    },
    actions: {
      copyLink: 'Copiar Link',
      sendEmail: 'Enviar Email',
      sending: 'Enviando...',
      sendWhatsapp: 'Enviar WhatsApp',
    },
    fields: {
      emailPlaceholder: 'Email do cliente',
      phonePlaceholder: 'Telefone do cliente (com código de país)',
    },
    hints: {
      expiry: 'Este link expira em 7 dias',
      phoneFormat: 'Formato: +55 (99) 99999-9999',
    },
    infoList: {
      valid: 'O link é válido por 7 dias',
      confirmOrCancel: 'O cliente pode confirmar ou cancelar pelo link',
      confirmationNotice: 'Após a confirmação, você receberá uma notificação',
      singleUse: 'O link não consegue ser reutilizado',
    },
  },
  modelsFormsPage: {
    toast: {
      errorTitle: 'Erro',
      listError: 'Erro ao listar prontuários',
    },
    intro: {
      badge: 'Modelos',
      title: 'Modelos de prontuários',
      description:
        'Mantenha os modelos clínicos organizados em uma visualização alinhada com o novo padrão das telas internas.',
    },
    actions: {
      refresh: 'Atualizar',
      create: 'Cadastrar',
      edit: 'Editar',
    },
    table: {
      title: 'Titulo',
      status: 'Status',
      options: 'Opções',
    },
  },
  modelsDocumentsPage: {
    toast: {
      errorTitle: 'Erro',
      listError: 'Erro ao listar modelos',
    },
    intro: {
      badge: 'Modelos',
      titleDocuments: 'Modelos de documentos',
      titlePrescriptions: 'Modelos de receituários',
      descriptionDocuments:
        'Centralize os modelos usados na clínica em uma listagem mais clara e consistente com o restante da interface.',
      descriptionPrescriptions:
        'Organize os modelos de receituário eletrônico com o mesmo fluxo de assinatura e impressão já usado pelo sistema.',
    },
    actions: {
      refresh: 'Atualizar',
      create: 'Cadastrar',
      createPrescription: 'Cadastrar receituário',
      edit: 'Editar',
    },
    filters: {
      documents: 'Documentos',
      prescriptions: 'Receituários',
    },
    table: {
      index: '#',
      title: 'Título',
      status: 'Status',
      options: 'Opções',
    },
  },
  insertPayment: {
    toast: {
      errorTitle: 'Erro',
      fillAllFields: 'Preencha todos os campos',
    },
    installments: {
      single: '{{count}} vez',
      multiple: '{{count}} vezes',
    },
    modal: {
      title: 'Inserir Pagamento',
      ok: 'Inserir',
    },
    fields: {
      paymentMethod: 'Forma de Pagamento',
      paymentMethodPlaceholder: 'Selecione a forma de pagamento',
      value: 'Valor',
      installments: 'Qtd. Parcelas',
      installmentsPlaceholder: 'Selecione a quantidade de parcelas',
      dueDate: 'Data de Vencimento',
    },
  },
  treatmentProductsModal: {
    messages: {
      loadProductsError: 'Erro ao carregar produtos',
      loadTreatmentProductsError: 'Erro ao carregar produtos do tratamento',
      addSuccess: 'Produto adicionado com sucesso',
      addError: 'Erro ao adicionar produto',
      updateError: 'Erro ao atualizar produto',
      removeSuccess: 'Produto removido com sucesso',
      removeError: 'Erro ao remover produto',
    },
    modal: {
      title: 'Produtos do Tratamento {{suffix}}',
      dentalSuffix: 'Odontológico',
      close: 'Fechar',
    },
    table: {
      product: 'Produto',
      quantity: 'Quantidade',
      unitPrice: 'Preço Unitário',
      total: 'Total',
      actions: 'Ações',
      notFound: 'Produto não encontrado',
    },
    addSection: {
      title: 'Adicionar Novo Produto',
      helper: 'Selecione um produto para adicionar',
      placeholder: 'Procure por código ou nome',
      button: 'Adicionar',
      allAdded: 'Todos os produtos disponíveis já foram adicionados',
    },
    addedSection: {
      title: 'Produtos Adicionados',
      empty: 'Nenhum produto adicionado',
      emptyHelper: 'Selecione um produto acima para começar',
      helper: 'Edite quantidade e preço conforme necessário',
    },
    summary: {
      totalProducts: 'Total de Produtos:',
      totalValue: 'Valor Total:',
    },
    retail: {
      loadProductsError: 'Erro ao carregar produtos para venda avulsa',
      selectProductWarning: 'Selecione um produto para continuar',
      quantityWarning: 'Informe uma quantidade maior que zero',
      unitPriceWarning: 'O valor unitário não pode ser negativo',
      modalTitle: 'Produtos Avulsos da Venda',
      modalOk: 'Concluir',
      buildSaleTitle: 'Montar venda avulsa',
      product: 'Produto',
      productPlaceholder: 'Procure por código ou nome',
      quantity: 'Quantidade',
      unitPrice: 'Valor unitário',
      addButton: 'Adicionar',
      helper:
        'Use esta área para produtos vendidos no atendimento, mas que não precisam ficar vinculados clinicamente ao protocolo do tratamento. Apenas itens marcados como produto para venda aparecem aqui.',
      itemsTitle: 'Itens da venda avulsa',
      empty: 'Nenhum produto avulso adicionado',
      productNotFound: 'Produto não encontrado',
      actions: 'Ações',
      detachedItems: 'Itens avulsos',
      projectedTotal: 'Total previsto',
    },
  },
  usersPage: {
    validation: {
      nameRequired: 'Nome obrigatório',
      cpfRequired: 'CPF obrigatório',
      invalidCpf: 'cpf inválido',
      phoneRequired: 'Celular obrigatório',
      birthDateRequired: 'Data de nascimento obrigatória',
      loginRequired: 'Login obrigatório',
      accessGroupRequired: 'Grupo de acesso obrigatório',
      passwordRequired: 'Senha obrigatória',
      passwordConfirmationRequired: 'Confirmação de senha obrigatória',
      passwordMismatch: 'Senha não coincide com senha de confirmação.',
    },
    toast: {
      errorTitle: 'Erro',
      blankFields: 'Campos em branco',
      listError: 'Erro ao listar planos de contas',
      listAccessGroupsError: 'Erro ao listar os grupos de acesso',
      updatedTitle: 'Usuário alterado',
      updatedDescription: 'Dados de usuário alterado com sucesso.',
      createdTitle: 'Usuário cadastrado',
      createdDescription: 'Usuário cadastrado com sucesso.',
      editError: 'Erro ao alterar.',
      createError: 'Erro ao cadastrar',
    },
    intro: {
      badge: 'Cadastros',
      listTitle: 'Usuários',
      listDescription:
        'Gerencie contas internas, acessos e redefinições de senha com o mesmo layout usado nas demais telas administrativas.',
      createTitle: 'Cadastrar usuário',
      editTitle: 'Editar usuário',
      formDescription:
        'Defina dados pessoais, grupo de acesso e credenciais em uma tela padronizada com o restante do sistema.',
    },
    actions: {
      refresh: 'Atualizar',
      create: 'Cadastrar',
      edit: 'Editar',
      resetPassword: 'Resetar Senha',
    },
    table: {
      cpf: 'CPF',
      name: 'Nome',
      birthDate: 'Nascimento',
      login: 'Login',
      status: 'Status',
      options: 'Opções',
    },
    fields: {
      name: 'Nome',
      namePlaceholder: 'Insira o nome',
      cpf: 'CPF',
      cpfPlaceholder: 'Insira o CPF',
      birthDate: 'Data Nascimento',
      accessGroup: 'Grupo de Acesso',
      phone: 'Telefone',
      phonePlaceholder: 'Insira o Telefone',
      loginEmail: 'E-mail (Login)',
      password: 'Senha',
      passwordPlaceholder: 'Insira a senha',
      passwordConfirmation: 'Confirmação de senha',
      passwordConfirmationPlaceholder: 'Confirme sua senha',
      active: 'Ativo',
    },
    resetPassword: {
      modalTitle: 'Resetar senha?',
      confirmButton: 'Resetar',
      description: 'Deseja resetar a senha para padrão [1 a 6]?',
      successTitle: 'Sucesso',
      successDescription: 'Senha resetada com sucesso',
      errorDescription: 'Erro ao resetar.',
    },
  },
  companiesPage: {
    toast: {
      errorTitle: 'Erro',
      successTitle: 'Sucesso',
      fetchCompaniesError: 'Erro ao buscar empresas.',
      fetchPlansError: 'Erro ao buscar planos globais.',
      saveConfigSuccess: 'Status alterado com sucesso!',
      createTenantSuccess: 'Empresa cadastrada com sucesso!',
      serverConnectionError: 'Erro ao conectar com o servidor',
      savePlanSuccess: 'Plano salvo com sucesso!',
      savePlanError: 'Erro ao salvar plano.',
    },
    shared: {
      none: 'Nenhum',
      notAvailable: '-',
      currencyPrefix: 'R$',
    },
    permission: {
      checking: 'Verificando permissões...',
      deniedTitle: 'Acesso Negado',
      deniedDescription:
        'Esta é uma área restrita para gerenciamento do sistema.',
      deniedHelper:
        'Apenas o perfil administrador do tenant gerente possui permissão de acesso.',
    },
    breadcrumb: {
      home: 'Início',
      current: 'Empresas',
    },
    header: {
      title: 'Gerenciamento de Empresas (Tenants)',
    },
    summary: {
      total: 'Total de tenants',
      active: 'Tenants ativos',
      blocked: 'Tenants bloqueados',
    },
    helperText:
      'Cadastre novos tenants e gerencie os módulos e bloqueios por empresa.',
    actions: {
      back: 'Voltar',
      refresh: 'Atualizar',
      newTenant: 'Novo Tenant',
      newPlan: 'Novo Plano',
      edit: 'Editar',
      configure: 'Configurações',
    },
    status: {
      tenant: {
        active: 'Ativo',
        blocked: 'Bloqueado',
      },
      enabled: {
        active: 'Ativo',
        inactive: 'Inativo',
      },
      plan: {
        active: 'Ativo',
        trial: 'Trial',
        suspended: 'Suspenso',
        canceled: 'Cancelado',
      },
    },
    landing: {
      visible: 'Visível',
      hidden: 'Oculto',
    },
    legacyModules: {
      dental: 'Odontológico',
      medical: 'Médico',
      aesthetics: 'Estética',
    },
    modules: {
      agenda: 'Controle de Agenda',
      clientes: 'Cadastro de Clientes',
      financeiro: 'Financeiro',
      documentos: 'Documentos',
      assinatura_digital: 'Assinatura Digital',
      tratamentos: 'Tratamentos Clínicos',
      odontologico: 'Odontologia',
      atestados_medicos: 'Atestados Médicos',
      formularios: 'Formulários',
      guias: 'Guias',
      convenios: 'Convênios e Terminologias',
      estetica: 'Estética',
      estoque: 'Estoque',
      produtos: 'Produtos',
      usuarios: 'Usuários',
      permissoes: 'Permissões e Grupos de Acesso',
      profissionais: 'Profissionais',
      especialidades: 'Especialidades',
      procedimentos: 'Procedimentos',
      whatsapp: 'WhatsApp',
      email: 'E-mail',
      empresa: 'Dados da Empresa',
    },
    autoConfirmationChannels: {
      both: 'WhatsApp e E-mail',
      whatsapp: 'Somente WhatsApp',
      email: 'Somente E-mail',
      disabled: 'Desativado',
    },
    table: {
      plans: {
        title: 'Planos Globais',
        empty: 'Nenhum plano global cadastrado.',
        limitSummary:
          '{{users}} usuários / {{professionals}} profissionais / {{clients}} clientes',
        columns: {
          code: 'Código',
          name: 'Nome',
          monthlyFee: 'Mensalidade',
          limits: 'Limites',
          status: 'Status',
          landing: 'Landing',
          actions: 'Ações',
        },
      },
      tenants: {
        title: 'Empresas Cadastradas',
        empty: 'Nenhuma empresa cadastrada.',
        columns: {
          name: 'Nome',
          status: 'Status',
          activeModules: 'Módulos Ativos',
          plan: 'Plano',
          dueDate: 'Vencimento (dias)',
          createdAt: 'Data Criação',
          actions: 'Ações',
        },
      },
    },
    createTenantModal: {
      title: 'Cadastrar Tenant',
      helper: 'Esse nome sera usado para criar o schema isolado da empresa.',
      fields: {
        identifier: 'Identificador do tenant',
        identifierPlaceholder: 'Ex: clinica_central',
      },
      validation: {
        required: 'Informe o nome do tenant.',
        alreadyExists: 'Já existe uma clínica com esse identificador.',
        createError: 'Erro ao cadastrar tenant.',
      },
    },
    planModal: {
      titleCreate: 'Novo Plano',
      titleEdit: 'Editar Plano {{name}}',
      saveButton: 'Salvar Plano',
      sections: {
        landing: 'Informações da Landing',
        allowedModules: 'Módulos liberados por este plano',
      },
      fields: {
        code: 'Código:',
        name: 'Nome:',
        description: 'Descrição:',
        landingSubtitle: 'Subtítulo do plano:',
        landingPrice: 'Preço exibido na landing:',
        landingPricePlaceholder: 'Ex: Sob consulta',
        landingFrequency: 'Frequência exibida:',
        landingFrequencyPlaceholder: 'Ex: /mês',
        landingHighlight: 'Destaque do card:',
        landingHighlightPlaceholder: 'Ex: Mais escolhido',
        landingSortOrder: 'Ordem na landing:',
        landingFeatures: 'Lista de benefícios da landing:',
        landingFeaturesPlaceholder: 'Um item por linha',
        monthlyPriceCents: 'Mensalidade em centavos:',
        maxUsers: 'Máximo de Usuários:',
        maxProfessionals: 'Máximo de Profissionais:',
        maxClients: 'Máximo de Clientes:',
        defaultDueDate: 'Vencimento padrão:',
      },
      checkboxes: {
        landingVisible: 'Exibir este plano na landing page',
        recommendedDental: 'Odontológico por padrão',
        recommendedMedical: 'Médico por padrão',
        recommendedAesthetics: 'Estética por padrão',
        recommendedShowClientCode: 'Mostrar código do cliente por padrão',
        status: 'Plano ativo',
      },
      allowedModulesHelper:
        'Marque os módulos que o cliente terá acesso ao contratar este plano.',
    },
    configModal: {
      title: 'Configurações de {{name}}',
      loadError: 'Erro ao carregar configurações.',
      sections: {
        planManager: 'Gerenciador de Plano',
        overrides: 'Overrides do Tenant',
        moduleOverrides: 'Exceção de Módulos',
      },
      fields: {
        autoConfirmationChannel:
          'Canal automático de confirmação de agendamento:',
        planSuggestions: 'Sugestões de Plano:',
        planSuggestionsPlaceholder: 'Selecione um plano sugerido',
        planStatus: 'Status do Plano:',
        planStartedAt: 'Início do Plano (YYYY-MM-DD):',
        planEndsAt: 'Fim do Plano (YYYY-MM-DD):',
        maxUsers: 'Limite de Usuários:',
        maxProfessionals: 'Limite de Profissionais:',
        maxClients: 'Limite de Clientes:',
        dueDate: 'Dias para Vencimento:',
      },
      checkboxes: {
        blockClient: 'Bloquear Cliente',
        dentalModule: 'Módulo Odontológico',
        medicalModule: 'Módulo Médico',
        aestheticsModule: 'Módulo Estética',
        showClientCode: 'Mostrar Código do Cliente',
        customizeModules: 'Personalizar módulos para este cliente',
      },
      planCard: {
        noPlanSelected: 'Nenhum plano selecionado',
        code: 'Código: {{code}}',
        monthlyFee: 'Mensalidade: {{amount}}',
        basePlan:
          'Plano base: {{users}} usuários, {{professionals}} profissionais, {{clients}} clientes',
        descriptionEmpty: 'Selecione um plano para ver os detalhes.',
      },
      overridesHelper:
        'Se você mudar algum valor abaixo, ele passa a valer só para este cliente sem alterar o plano global.',
      moduleOverridesHelper:
        'Deixe em branco para herdar os módulos do plano. Marque aqui apenas se quiser liberar ou restringir módulos específicos só para este cliente.',
    },
  },
  dentalPage: {
    intro: {
      badge: 'Odontologia',
      title: 'Orçamentos e tratamentos odontológicos',
      description:
        'Centralize aprovações, andamento clínico e assinaturas dos tratamentos odontológicos em uma visão única.',
    },
    actions: {
      refresh: 'Atualizar',
      create: 'Cadastrar',
      moreActions: 'Mais ações',
      back: 'Voltar',
      view: 'Visualizar',
      approveOrReject: 'Aprovar/Recusar',
      edit: 'Editar',
      evolution: 'Evolução',
      print: 'Imprimir',
    },
    toast: {
      errorTitle: 'Erro',
      listError: 'Erro ao listar tratamentos',
    },
    stats: {
      total: 'Total',
      approved: 'Aprovados',
      pending: 'Pendentes',
      inProgress: 'Em andamento',
    },
    filters: {
      all: 'Todos',
      budgets: 'Orçamentos',
      treatments: 'Tratamentos',
    },
    searchPlaceholder: 'Pesquisar...',
    table: {
      id: 'Id',
      type: 'Tipo',
      typeTreatmentShort: 'TRAT',
      typeBudgetShort: 'ORÇ',
      client: 'Cliente',
      professional: 'Profissional',
      total: 'Total',
      progress: 'Progresso',
      status: 'Situação',
      signature: 'Assinatura',
      actions: 'Opções',
    },
    status: {
      approved: 'Aprovado',
      rejected: 'Recusado',
      pending: 'Pendente',
    },
    signature: {
      signed: 'Assinado',
      notSigned: 'Não assinado',
    },
  },
  dentalCreateEdit: {
    intro: {
      createTreatmentTitle: 'Cadastrar tratamento',
      createBudgetTitle: 'Cadastrar orçamento',
      editTreatmentTitle: 'Editar tratamento',
      editBudgetTitle: 'Editar orçamento',
      codeSuffix: 'Nº {{code}}',
    },
    types: {
      treatment: 'Tratamento',
      budget: 'Orçamento',
    },
    sections: {
      basicInfo: 'Informações básicas',
      odontogram: 'Odontograma dental',
      procedures: 'Procedimentos odontológicos',
    },
    fields: {
      procedureType: 'Tipo de procedimento',
      patient: 'Paciente',
      professional: 'Profissional',
    },
    tooltips: {
      procedureType: 'Selecione se é um tratamento completo ou orçamento',
      patient: 'Selecione o paciente responsável',
      professional: 'Selecione o profissional responsável',
    },
    placeholders: {
      patient: 'Selecione o paciente',
      professional: 'Selecione o profissional',
    },
    actions: {
      edit: 'Editar',
      remove: 'Remover',
      back: 'Voltar',
    },
    emptyState: {
      title: 'Nenhum procedimento odontológico adicionado ainda',
      description: 'Clique nos dentes no odontograma acima para começar',
    },
    table: {
      tooth: 'Dente',
      face: 'Face',
      currentState: 'Estado atual',
      procedure: 'Procedimento',
      unitValue: 'Valor UN.',
      discount: 'Desconto',
      total: 'Total',
      actions: 'Ações',
    },
    summary: {
      subtotal: 'Subtotal dos procedimentos:',
      discount: 'Desconto total:',
      totalToPay: 'Total a pagar:',
    },
    savedNotice: {
      title: 'Registro salvo:',
      description:
        'Este {{type}} odontológico foi salvo com sucesso (Nº {{code}}). Você pode visualizá-lo em detalhes ou imprimi-lo usando a opção de impressão.',
    },
    toast: {
      successTitle: 'Sucesso',
      savedTitle: 'Tratamento salvo',
      errorTitle: 'Erro',
      blankFieldsTitle: 'Campos em branco',
      createdDescription: '{{type}} cadastrado com sucesso',
      approvalRedirectWarning:
        'O tratamento foi salvo, mas não foi possível abrir a tela de aprovação automaticamente.',
      createError: 'Erro ao cadastrar.',
      loadError: 'Erro ao consultar.',
      listClientsError: 'Erro ao listar os clientes.',
      listProfessionalsError: 'Erro ao listar os profissionais',
    },
    odontogram: {
      invalidCondition: 'ID inválido',
      conditions: {
        amalgam: 'Amálgama',
        caries: 'Cáries',
        endodontics: 'Endodontia',
        missing: 'Ausente',
        resin: 'Resina',
        implant: 'Implante',
        sealant: 'Selante',
        crown: 'Coroa',
        other: 'Outros',
        clear: 'Limpar',
      },
    },
    procedureModal: {
      toast: {
        successTitle: 'Sucesso',
        infoTitle: 'Alterado',
        errorTitle: 'Erro',
        insertedDescription: 'Procedimento inserido',
        updatedDescription: 'Procedimento alterado',
        insertError: 'Erro ao inserir procedimento',
        editError: 'Erro ao editar procedimento',
      },
      titleCreate: 'Inserir procedimento',
      titleEdit: 'Editar procedimento',
      fields: {
        procedure: 'Procedimento',
        procedurePlaceholder: 'Selecione o procedimento',
        price: 'Preço',
        toothNumber: 'Número dente',
        toothFace: 'Face dente',
        currentState: 'Estado atual',
      },
    },
  },
  odontogramRender: {
    title: 'Odontograma',
    instructions:
      'Clique nas faces dos dentes para aplicar condições odontológicas',
    arches: {
      upperAdult: 'Arcada Superior - Adulto',
      upperChild: 'Arcada Superior - Infantil',
      lowerChild: 'Arcada Inferior - Infantil',
      lowerAdult: 'Arcada Inferior - Adulto',
    },
    toast: {
      selectConditionTitle: 'Aviso',
      selectConditionDescription: 'Selecione uma condição para o dente.',
    },
    conditions: {
      amalgam: 'Amálgama',
      caries: 'Cáries',
      endodontics: 'Endodontia',
      missing: 'Ausente',
      resin: 'Resina',
      implant: 'Implante',
      sealant: 'Selante',
      crown: 'Coroa',
      other: 'Outros',
    },
  },
  modelsHealthCertificatesPage: {
    intro: {
      badge: 'Modelos',
      title: 'Modelos de atestados',
      description:
        'Gerencie os modelos de atestados com o mesmo padrão visual aplicado às demais telas de configuração e cadastro.',
    },
    actions: {
      refresh: 'Atualizar',
      create: 'Cadastrar',
      edit: 'Editar',
    },
    table: {
      index: '#',
      title: 'Título',
      status: 'Status',
      options: 'Opções',
    },
    toast: {
      errorTitle: 'Erro',
      listError: 'Erro ao listar modelos',
    },
  },
  modelsHealthCertificatesCreateEdit: {
    intro: {
      badge: 'Modelos',
      createTitle: 'Cadastrar modelo de atestado',
      editTitle: 'Editar modelo de atestado',
      description:
        'Estruture modelos de atestados reutilizáveis seguindo o padrão visual interno do sistema.',
    },
    sections: {
      basicInfo: 'Informações básicas',
      keywords: 'Palavras-chave disponíveis',
      content: 'Conteúdo do atestado',
      status: 'Status do modelo',
    },
    instructions: {
      basicInfo:
        'Defina um título claro para identificar este modelo de atestado na listagem e no cadastro.',
      keywords:
        'Copie e cole as palavras-chave no texto do atestado. Elas serão automaticamente substituídas pelos dados do paciente quando o atestado for gerado.',
      content:
        'Escreva o texto do atestado. Use as palavras-chave acima para inserir dados dinâmicos que serão preenchidos automaticamente.',
      status:
        'Desative o modelo para ocultá-lo dos usuários sem perder o conteúdo configurado.',
    },
    fields: {
      title: 'Título do atestado',
      text: 'Texto',
      status: 'Ativar modelo',
    },
    placeholders: {
      title: 'Ex.: ATESTADO DE COMPARECIMENTO',
      titleHelp:
        'Digite um nome descritivo para este modelo (ex: ATESTADO DE COMPARECIMENTO)',
    },
    tooltips: {
      title: 'Nome que identifica este modelo de atestado',
      status: 'Desative para ocultar este modelo dos usuários',
    },
    status: {
      active: 'ATIVO',
      inactive: 'INATIVO',
    },
    toast: {
      errorTitle: 'Erro',
      blankFieldsTitle: 'Campos em branco',
      createdTitle: 'Cadastrado',
      createdDescription: 'Cadastrado com sucesso.',
      updatedTitle: 'Alterado',
      updatedDescription: 'Dados alterados com sucesso.',
      createError: 'Erro ao cadastrar modelo de atestado',
      editError: 'Erro ao editar modelo de atestado',
    },
    validation: {
      titleRequired: 'Nome obrigatório',
    },
  },
  patientHealthCertificatePrint: {
    error: {
      load: 'Não foi possível carregar o atestado para impressão.',
      notFound: 'Atestado não encontrado.',
    },
    actions: {
      backToPanel: 'Voltar ao painel',
    },
  },
  healthCertificateCreateEdit: {
    intro: {
      badge: 'Documentos',
      createTitle: 'Cadastrar atestado',
      editTitle: 'Editar atestado',
      description:
        'Monte o atestado com modelo, paciente, profissional e assinatura dentro do novo padrão visual da aplicação.',
    },
    sections: {
      selection: 'Selecionar modelo e pessoas',
      appointmentInfo: 'Informações do atendimento',
      keywords: 'Palavras-chave disponíveis',
      content: 'Conteúdo do atestado',
    },
    instructions: {
      selection:
        'Selecione o modelo de atestado, o paciente e o profissional responsável. O modelo carregará automaticamente o texto do atestado.',
      appointmentInfo:
        'Preencha os horários, data e duração do atendimento. O código CID é opcional.',
      keywords:
        'Copie e cole as palavras-chave no texto do atestado. Elas serão automaticamente substituídas pelos dados preenchidos acima quando o atestado for gerado.',
      content:
        'Escreva o conteúdo do atestado. Use as palavras-chave acima para inserir dados dinâmicos que serão preenchidos automaticamente com as informações do atendimento.',
    },
    fields: {
      model: 'Modelo de atestado',
      patient: 'Paciente',
      professional: 'Profissional',
      startTime: 'Hora inicial',
      endTime: 'Hora final',
      date: 'Data do atendimento',
      quantityDays: 'Quantidade de dias',
      cid: 'Código CID (Opcional)',
      text: 'Texto do atestado',
    },
    placeholders: {
      model: 'Modelo de atestado',
      patient: 'Paciente',
      professional: 'Profissional',
      cid: 'Ex.: J06 - Infecção do trato respiratório superior',
    },
    tooltips: {
      model: 'Selecione o template do atestado',
      patient: 'Selecione o paciente responsável pelo atestado',
      professional: 'Selecione o profissional responsável',
      startTime: 'Hora de início do atendimento',
      endTime: 'Hora de término do atendimento',
      date: 'Data em que o atendimento ocorreu',
      quantityDays: 'Número de dias do tratamento/atestado',
      cid: 'Classificação Internacional de Doenças (ex: J06)',
    },
    keywords: {
      patientName: 'Nome do paciente',
      patientCpf: 'CPF do paciente',
      daysCount: 'Quantidade de dias do tratamento',
      appointmentDate: 'Data do atendimento',
      startTime: 'Hora de início do atendimento',
      endTime: 'Hora de término do atendimento',
      cid: 'Código CID (Classificação Internacional de Doenças)',
    },
    warning: {
      title: '⚠️ Importante:',
      descriptionStart:
        'As palavras-chave devem ser digitadas exatamente como mostrado acima (com as chaves',
      descriptionEnd: 'e sem espaços).',
    },
    actions: {
      copyKeyword: 'Copiar palavra-chave',
      back: 'Voltar',
    },
    toast: {
      errorTitle: 'Erro',
      blankFieldsTitle: 'Campos em branco',
      createdTitle: 'Cadastrado',
      createdDescription: 'Cadastrado com sucesso.',
      updatedTitle: 'Alterado',
      updatedDescription: 'Dados alterados com sucesso.',
      createError: 'Erro ao cadastrar',
      editError: 'Erro ao editar',
      listProfessionalsError: 'Erro ao listar os profissionais',
      listModelsError: 'Erro ao listar os modelos de atestado',
      keywordCopiedTitle: 'Copiado',
      keywordCopiedDescription:
        'Palavra-chave "{{keyword}}" copiada para a área de transferência',
    },
    validation: {
      startTimeRequired: 'Hora inicial obrigatória',
      endTimeRequired: 'Hora final obrigatória',
      futureDate: 'Data não pode ser futura',
      dateRequired: 'Data do atendimento obrigatória',
      clientRequired: 'Cliente obrigatório',
      professionalRequired: 'Profissional obrigatório',
      modelRequired: 'Modelo de atestado obrigatório',
      textRequired: 'Campo de texto obrigatório',
    },
  },
  scheduleConfirmationMessageModal: {
    title: 'Enviar confirmação de agendamento',
    description:
      'Enviar confirmação para {{clientName}}. Agendamento: {{date}}',
    actions: {
      sendWhatsapp: 'Enviar via WhatsApp',
      sendSms: 'Enviar via SMS',
    },
    channels: {
      whatsapp: 'WhatsApp',
      sms: 'SMS',
    },
    toast: {
      successTitle: 'Sucesso',
      successDescription: 'Mensagem via {{channel}} enviada com sucesso!',
      errorTitle: 'Erro',
      errorDescription: 'Erro ao enviar mensagem.',
    },
    sendConfirmationModal: {
      title: 'Enviar Confirmação de Agendamento - {{name}}',
      close: 'Fechar',
      tabs: {
        email: 'Email',
        whatsapp: 'WhatsApp',
      },
      linkCard: {
        title: 'Link de Confirmação',
        copy: 'Copiar Link',
        copiedTitle: 'Link copiado',
        copiedDescription:
          'Link de confirmação copiado para a área de transferência!',
        expires: 'Este link expira em 7 dias',
      },
      fields: {
        email: 'Endereço de Email',
        emailPlaceholder: 'cliente@exemplo.com',
        phone: 'Número de Telefone',
        phonePlaceholder: '+55 (11) 99999-9999',
        phoneHelp: 'Use o formato: +55 (DDD) 9XXXX-XXXX',
      },
      actions: {
        sendEmail: 'Enviar Email',
        sendEmailLoading: 'Enviando...',
        sendWhatsapp: 'Enviar WhatsApp',
        sendWhatsappLoading: 'Enviando...',
      },
      loading: 'Gerando link de confirmação...',
      info: 'O cliente receberá um link para confirmar ou cancelar seu agendamento. O link expira em 7 dias e pode ser utilizado apenas uma vez.',
      toast: {
        errorTitle: 'Erro',
        successTitle: 'Sucesso',
        tokenError: 'Erro ao gerar token de confirmação',
        emailRequired: 'Informe um endereço de email',
        emailSent: 'Email de confirmação enviado com sucesso!',
        emailError: 'Erro ao enviar email',
        phoneRequired: 'Informe um número de telefone',
        whatsappSent: 'Mensagem WhatsApp enviada com sucesso!',
        whatsappError: 'Erro ao enviar WhatsApp',
      },
    },
  },
  upload: {
    defaultLabel: 'Upload da assinatura em PNG',
  },
} as const;

export default locale;
